import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { deleteOffer, getSupply } from "../../api/offers";
import { Offer } from "../../models/offers";
import DeleteOfferModal from "../../components/SuperDashboard/ManageOffers/DeleteOfferModal";
import SupplyCard from "../../components/SuperDashboard/ManageSupply/SupplyCard";
import AssignSupplyModal from "../../components/SuperDashboard/ManageSupply/AssignSupplyModal";
import { deleteZipList } from "../../api/fileSystem";

export default function SuperManageSupplyPage() {
    const [supplyList, setSupplyList] = useState<Offer[]>([]);
    const [isEditOpen, setEditOpen] = useState(false);
    const [editingSupply, setEditingSupply] = useState<Offer | null>(null);
    const [deletingSupply, setDeletingSupply] = useState<Offer | null>(null);
    const [assigningSupply, setAssigningSupply] = useState<Offer | null>(null);

    const handleDelete = (supply: Offer) => {
        setDeletingSupply(supply);
    }

    const handleAssign = (supply: Offer) => {
        setAssigningSupply(supply);
    }

    const confirmDelete = async (deletingSupply: Offer) => {
        try {
            await deleteOffer(deletingSupply.id);
            await deleteZipList(deletingSupply.id);

            setSupplyList(prev => prev.filter(o => o.id !== deletingSupply.id));
            toast.success("Supply deleted");
        } catch (err) {
            toast.error("Failed to delete offer");
        } finally {
            setDeletingSupply(null);
        }
    }

    const confirmAssign = async (migratingSupply: Offer) => {
        try {
            //send email logic
            toast.success("Supply assign still not implemented");
        } catch (err) {
            toast.error("Failed to migrate offer");
        } finally {
            setAssigningSupply(null);

        }
    }
    const handleEdit = (supply: Offer) => {
        setEditingSupply(supply);
        setEditOpen(true);
    };
    const handleSupplyUpdated = (updatedSupply: Offer) => {
        setSupplyList((prev) =>
            prev.map((u) => (u.id === updatedSupply.id ? updatedSupply : u))
        );
    };
    const fetchAllSupply = async () => {
        try {
            const result = await getSupply();
            setSupplyList(result);
        } catch (error: any) {
            toast.error(error?.message || "Failed to fetch Supply List");
        }
    };

    useEffect(() => {
        fetchAllSupply();
    }, []);


    return (
        <>
            <div className="p-6 min-h-screen bg-gray-100 dark:bg-gray-900">
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                        Manage Supply
                    </h1>
                </div>

                {supplyList.map((supply) => (
                    <SupplyCard
                        key={supply.id}
                        id={supply.id}
                        vertical={supply.vertical}
                        category={supply.category}
                        offer_creator={supply.offer_creator}
                        onDelete={() => handleDelete(supply)}
                        onAssign={() => handleAssign(supply)}
                    />
                ))}
            </div>
            {deletingSupply && ( //we can use deeleting offer modal here because i migrated logic to work on both (I pass is supply varaible heree)
                <DeleteOfferModal offer_id={deletingSupply.id} onClose={() => { setDeletingSupply(null); }} onConfirm={() => confirmDelete(deletingSupply)} isSupply={true} />
            )
            }
            {assigningSupply && (
                <AssignSupplyModal offer_id={assigningSupply.id} onClose={() => { setAssigningSupply(null); }} onConfirm={() => confirmAssign(assigningSupply)} />
            )
            }
        </>
    );
}
